import Button from './Button.svelte';

export default {
  component: Button,
  name: 'Button',
  inputs: [
    {
      name: 'label',
      type: 'string',
      defaultValue: 'Button label'
    },
    {
      name: 'href',
      type: 'string'
    },
    {
      name: 'kind',
      type: 'string',
      defaultValue: 'primary',
      enum: ['primary', 'secondary', 'tertiary', 'ghost', 'ghost-alt', 'danger', 'success', 'warning']
    }
  ]
}